module.exports = __webpack_public_path__ + "img/foundationIllustrationMiscVayuInformation@3x.f369d2b5.png";